import Region from "models/profiles/newsletters/region"

class Subscription {
  constructor(attributes) {
    this.blurb = attributes.blurb
    this.frequency = attributes.frequency
    this.available = attributes.available
    this.slug = attributes.slug
    this.logoUrl = attributes.logoUrl
    this.name = attributes.name
    this.subscribed = attributes.subscribed
    this.region = new Region(attributes.region)
  }
}

export default Subscription
